import Loading from 'app/atoms/Loading';
import { Suspense, useEffect, useState } from 'react';
import './NeighborhoodGuide.scss';
import NeighborhoodGuideHeroSection from './NeighborhoodGuideHeroSection/NeighborhoodGuideHeroSection';
import NeighborhoodGuideContent from './NeighborhoodGuideContent/NeighborhoodGuideContent';
import TitledPropertyCarouselSection from 'app/molecules/TitledPropertyCarouselSection/TitledPropertyCarouselSection';
import { useParams } from 'react-router';
import { sanityClient } from '../../../sanity.io/config';
import { NeighborhoodGuideProps } from './NeighborhoodGuide.types';
import Copyright from '../../molecules/Footer/Copyright';

function NeighborhoodGuide() {
  const { neighborhood } = useParams<{ neighborhood: string }>();
  const [data, setData] = useState<NeighborhoodGuideProps>();

  useEffect(() => {
    sanityClient.fetch(`*[ _type== "neighborhoodGuide" && slug.current == "${neighborhood.toLowerCase()}"]{ ..., city->}`).then(response => {
      if (response && response[0]) {
        setData(response[0]);
      }
    });
  }, []);
  return (
    <Suspense
      fallback={
        <div>
          <Loading force={true} />
        </div>
      }
    >
      <NeighborhoodGuideHeroSection
        neighborhood={data?.neighborhood}
        quintessentialExperience={data?.quintessentialExperience}
        heroImageUrl={data?.heroImage?.asset?._ref}
      />
      <section className="d-flex flex-column">
        <NeighborhoodGuideContent
          mainText1={data?.mainText1}
          mainText2={data?.mainText2}
          mainText3={data?.mainText3}
          favoriteRestaurants={data?.favoriteRestaurants}
          nightlifeWeLove={data?.nightlifeWeLove}
          theOtherGoodStuff={data?.theOtherGoodStuff}
          transitLinksandOtherItemsofNote={data?.transitLinksandOtherItemsofNote}
        />
        <div className="col-lg-12 col-md-12 copy-right copyright-neighborhood">
          <Copyright />
        </div>
        <TitledPropertyCarouselSection
          title=""
          subtitle={`Check out some of our most popular ${data?.neighborhood} homes`}
          url="/properties"
          city={data?.city.name}
        />
      </section>
    </Suspense>
  );
}
export default NeighborhoodGuide;
